module.exports = __webpack_public_path__ + "static/media/cloud1.48e2daf2.png";